import welcomingSVG from "../../assets/welcoming.svg";
import { useApps } from "../../context/appsContext";
import { useTranslations } from "../../hooks/useTranslations";
import LoadingSpinner from "../ui/LoadingSpinner";
import Page from "../ui/Page";
import Services from "../ui/Services";
import Footer from "./Footer";
import styles from "./Home.module.css";

const Home = () => {
  const { i18n } = useTranslations();
  const { recentlyUsedApps, isValidating } = useApps();

  return (
    <Page title={i18n.home.title} description={i18n.home.description}>
      <h2 className={styles.title}>{i18n.home.recentApps}</h2>
      {isValidating ? (
        <div className={styles.status}>
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <Services items={recentlyUsedApps} />
          {recentlyUsedApps.length === 0 && (
            <div className={styles.noApps}>
              <img src={welcomingSVG} className={styles.illustration} />
              {i18n.home.recentAppsEmpty}
            </div>
          )}
        </>
      )}
      <Footer />
    </Page>
  );
};

export default Home;
